import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../misc/guards/authenticated.guard';
import { LoginCredentialsPageComponent } from './login-credentials.page';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: LoginCredentialsPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class LoginCredentialsPageRoutingModule {}
